import { Box, Button, Grid, Typography } from '@mui/material'
import { ArrowForwardIcon } from 'src/assets/icons'
import { useNavigate } from 'react-router-dom'

type HeroProps = {
    typesOfTrustRef: React.MutableRefObject<HTMLDivElement | null>
}

const HeroSection = (props: HeroProps) => {
    const { typesOfTrustRef } = props
    const navigate = useNavigate()
    return (
        <Box>
            <Grid container className="tbmd:mt-6">
                <Grid item xs={12} md={4} className="mb-6 mt-10 pl-20 tbmd:px-6">
                    <Box className="animate__animated animate__fadeInLeft tbmd:text-center" >
                        <Typography
                            component="h1"
                            className="font-[Barlow] text-[70px] font-semibold leading-[80px] text-white tbmd:text-[45px] tbmd:leading-[50px]"
                        >
                            <span className="block">Service.</span>
                            <span className="block">Experience.</span>
                            <span className="block">Compassion.</span>
                        </Typography>
                    </Box>
                    <Typography className="mt-9 font-[Barlow] text-[16px] leading-[24px] text-white tbmd:text-center">
                        SCS Trust Services offers self-settled and third-party pooled and individual trust administration, specifically tailored to meet the
                        unique needs of each client.
                    </Typography>
                    <Box display="flex" alignItems="center" className="animate__animated animate__slideInUp mt-8 tbmd:justify-center">
                        <Button
                            className="h-[37px] rounded-[25px] bg-[#ffffff4d] text-[16px] hover:bg-white hover:text-[#364152]"
                            variant="contained"
                            onClick={() => {
                                navigate('/#types-of-trusts')
                                typesOfTrustRef.current?.scrollIntoView({ behavior: 'smooth' })
                            }}
                        >
                            LEARN MORE
                        </Button>
                        <Button
                            className="ml-2 h-[37px] rounded-[25px] text-white"
                            variant="text"
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => navigate('/auth/register')}
                        >
                            REGISTER
                        </Button>
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={8}
                    className="mt-10 flex h-[650px] justify-center bg-[url('/images/cc-transactions1.png')] bg-contain bg-right bg-no-repeat tbmd:mt-24 tbmd:h-[318.49px] tbmd:w-full tbmd:bg-center "
                >
                    <img
                        className="animate__animated animate__slideInUp -mt-10 h-[589px] [--animate-duration:2s] tbmd:h-[491px]"
                        src="https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,h_640/scs/site/phone-fade_y3pdgo.gif"
                        srcSet="https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,h_480/scs/site/phone-fade_y3pdgo.gif 480w, https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,h_640/scs/site/phone-fade_y3pdgo.gif 640w"
                        sizes="(max-width: 900px) 90vw, 640px"
                        width={446}
                        height={643}
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                        alt="phone-demo"
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default HeroSection
